import { nullsToUndefined } from "../../../../null.js";
import { productCardCirRxjsConverter } from "../../../circuitos/product-card-cir-rxjs/converter.js";
import { productCardCruisesDesktopConverter } from "../../../cruises/product-card-cruises/index.js";
import { productCardFliDesktopConverter } from "../../product-card-fli/index.js";
import { productCardPackagesDesktopConverter } from "../../../packages/product-card-packages/desktop/converter.js";
import { productCardHotelsDesktopConverter } from "../../../product-card-hotels/index.js";
const genericProductCardConverter = (productCard)=>{
    if (productCard.name === 'product-card-he') return productCard.props ?? productCard.data;
    if (productCard.name === 'product-card-packages') return productCardPackagesDesktopConverter(productCard);
    if (productCard.name === 'product-card-hotels') return productCardHotelsDesktopConverter(productCard);
    if (productCard.name === 'product-card-cir-rxjs') return productCardCirRxjsConverter(productCard);
    if (productCard.name === 'card-product-fli') return productCardFliDesktopConverter(productCard);
    if (productCard.name === 'product-card-cruises') return productCardCruisesDesktopConverter(productCard);
};
const getBanner = (banner)=>{
    if (!banner) return undefined;
    return {
        ...banner.image,
        src: banner.image?.src ?? '',
        title: banner.title
    };
};
export const bannerProductCardMarketingDesktopConverter = (tabProduct)=>{
    const { title ='' , isDeal  } = tabProduct;
    const dataOrProps = tabProduct.props ?? tabProduct.data;
    const props = dataOrProps.props ?? dataOrProps.data ?? {};
    const viewMore = props?.banner?.button?.content ?? nullsToUndefined(props.view_more?.link)?.content;
    return {
        config: {
            literals: {
                viewMore
            }
        },
        title,
        link: props.view_more?.link,
        banner: getBanner(props?.banner),
        hasImage: !!props.banner?.image,
        isDeal: isDeal ?? props.isDeal,
        items: props?.items?.map(genericProductCardConverter).filter((item)=>!!item)
    };
};
const generateAjaxComponentData = (tabProduct)=>{
    const { ajaxComponentData  } = tabProduct.props ?? tabProduct.data;
    const params = ajaxComponentData?.Arguments?.map(({ Name , Value , Key  })=>({
            name: Name,
            key: Key ?? '',
            value: Value
        })) ?? [];
    return {
        title: tabProduct.title ?? '',
        isDeal: tabProduct.isDeal,
        hasImage: true,
        params
    };
};
export const tabsProductCard = (tabProduct)=>{
    const props = tabProduct.props ?? tabProduct.data ?? {};
    if ('name' in props) return bannerProductCardMarketingDesktopConverter(tabProduct);
    if ('ajaxComponentData' in props) return generateAjaxComponentData(tabProduct);
};
export const tabsProductCardMarketingDesktopConverter = (tabsProps)=>{
    const props = tabsProps?.props ?? {};
    const { heading , tabs =[] , config ={}  } = props ?? {};
    return {
        ...tabsProps,
        props: {
            ...props,
            title: heading?.props?.title ?? '',
            config: {
                ...config,
                carousel: true,
                endpoint: config.endpoint
            },
            subtitle: heading?.props?.subtitle,
            items: tabs.map(tabsProductCard).filter((item)=>!!item),
            isFlat: true
        }
    };
};

//# sourceMappingURL=converter.js.map